import React from "react";
import accelerateReach from "../../assets/images/B2B-Data/accelerate_reach.png";
import buildValrel from "../../assets/images/B2B-Data/build-value-rel.png";
import optimizeEveryCamp from "../../assets/images/B2B-Data/optimizeEveryCamp.png";

const cardData = [
  {
    src: accelerateReach,
    title: "Accelerate Your Outreach",
    desc: "Find high-potential leads in seconds and start meaningful conversations faster.",
    bgColor: "tw-bg-[#F2F9FF]",
    iconBorder: "#C8E2FA",
    iconBg: "#E3F2FD",
    titleColor: "tw-text-[#457EB3]"
  },
  {
    src: buildValrel,
    title: "Build Valuable Relationships",
    desc: "Find high-potential leads in seconds and start meaningful conversations faster.",
    bgColor: "tw-bg-[#F5F3FC]",
    iconBorder: "#E1D5FD",
    iconBg: "#EDE7F6",
    titleColor: "tw-text-[#873BFB]"
  },
  {
    src: optimizeEveryCamp,
    title: "Optimize Every Campaign",
    desc: "Leverage precise targeting to boost engagement, drive conversions, and maximize ROI.",
    bgColor: "tw-bg-[#FCF4F2]",
    iconBorder: "#FDD5D1",
    iconBg: "#FFEBEE",
    titleColor: "tw-text-[#FF5845]"
  }
];

const WhyChooseUs = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Core value
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Why Choose Us?
          </h2>
        </div>

        {/* Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {cardData.map((item, idx) => (
            <div
              key={idx}
              className={`tw-relative tw-overflow-hidden ${item.bgColor} tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.03] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col`}
            >
              {/* Ghost watermark icon in background */}
              <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.08] tw-pointer-events-none">
                <img
                  src={item.src}
                  alt=""
                  aria-hidden="true"
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>

              {/* Icon Box */}
              <div
                className="tw-w-14 tw-h-14 tw-mb-6 tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-rounded-2xl"
                style={{
                  backgroundColor: item.iconBg,
                  border: `1.5px solid ${item.iconBorder}`,
                }}
              >
                <img
                  src={item.src}
                  alt={item.title}
                  className="tw-w-7 tw-h-7 tw-object-contain"
                />
              </div>

              {/* Text */}
              <h3 className={`tw-text-lg tw-font-bold ${item.titleColor} tw-mb-3`}>
                {item.title}
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0 tw-flex-grow">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;
